<template>
  <!-- Navbar start -->
  <div>
    <div class="container-fluid fixed-top px-0">
      <Loader v-if="isLoading" />
      <div class="container-fluid px-0">
        <div class="topbar">
          <div class="row align-items-center justify-content-center">
            <div class="col-md-8">
              <div class="topbar-info d-flex flex-wrap">
                <a href="#" class="text-light me-4"><i
                    class="fas fa-envelope text-white me-2"></i>cerisetechsolutions@gmail.com</a>
                <a href="#" class="text-light"><i class="fas fa-phone-alt text-white me-2"></i>+01234567890</a>
              </div>
            </div>
            <div class="col-md-4">
              <div class="topbar-icon d-flex align-items-center justify-content-end">
                <a href="#" class="btn-square text-white me-2"><i class="fab fa-facebook-f"></i></a>
                <a href="#" class="btn-square text-white me-2"><i class="fab fa-twitter"></i></a>
                <a href="#" class="btn-square text-white me-2"><i class="fab fa-instagram"></i></a>
                <a href="#" class="btn-square text-white me-2"><i class="fab fa-pinterest"></i></a>
                <a href="#" class="btn-square text-white me-0"><i class="fab fa-linkedin-in"></i></a>
              </div>
            </div>
          </div>
        </div>
        <nav class="navbar shadow navbar-expand-xl bg-white px-4">
          <a href="#" class="navbar-brand ms-3">
            <img @click="gotolanding" src="@/assets/images/cts_logo_hzl-wo_bg.png" height="50px" />
            <b style="color: #9678ff">CERISETECH SOLUTIONS PVT LTD</b>
          </a>
          <div class="collapse navbar-collapse" id="navbarCollapse">
            <div class="navbar-nav ms-auto"></div>
            <div class="d-flex align-items-center flex-nowrap pt-xl-0" style="margin-left: 15px">
              <div class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown">
                  {{ userdetails.fullname ? userdetails.fullname : userName }}
                  <img v-if="userdetails.employee_photo_path" class="employee-image" @click="gotolanding"
                    :src="userdetails.employee_photo_path" height="50px" />
                  <img v-else src="@/assets/images/profile.png" alt="Employee Photo" class="employee-image" />
                </a>
                <div class="dropdown-menu m-0 bg-secondary rounded-0">
                  <b @click="profile" class="dropdown-item">Profile</b>
                  <b @click="setting" class="dropdown-item">Settings</b>
                  <b @click="resetpassword" class="dropdown-item">Reset Password</b>
                  <b @click="logout" class="dropdown-item" style="cursor: pointer">Logout</b>
                </div>
              </div>
            </div>
          </div>
        </nav>
        <nav class="navbar shadow navbar-expand-xl bg-white px-4">
          <button class="navbar-toggler py-2 px-3 me-3" type="button" data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse">
            <span class="fa fa-bars text-primary"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarCollapse">
            <div class="navbar-nav">
              <a :href="Dashboard_link" class="nav-item nav-link">Dashboard</a>
              <template v-for="menu in menus" :key="menu.id">
                <!-- Top-Level Menu with No Sub-Menus -->
                <a v-if="!menu.subs.length" :href="menu.menu_url" class="nav-item nav-link">{{ menu.menu_name }}</a>
                <!-- Top-Level Menu with Sub-Menus -->
                <div v-else class="nav-item dropdown">
                  <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown">
                    {{ menu.menu_name }}
                  </a>
                  <div class="dropdown-menu m-0 bg-secondary rounded-0"
                    :style="{ overflowY: menu.subs.length > 8 ? 'auto' : 'visible', maxHeight: menu.subs.length > 8 ? '300px' : 'unset' }">
                    <!-- Sub-Menu Links -->
                    <a v-for="sub in menu.subs" :key="sub.id" :href="sub.menu_url" class="dropdown-item">
                      {{ sub.menu_name }}
                    </a>
                  </div>
                </div>
              </template>
            </div>

          </div>
        </nav>

      </div>

    </div>
    <div class="modal fade" id="resetModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
      data-bs-backdrop="static" data-bs-keyboard="false">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="exampleModalLabel">Reset Password</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form>
              <div class="form-group">
                <label for="recipient-name" class="col-form-label">Username</label>
                <input type="text" v-model="userdetails.user_name" class="form-control" id="recipient-name" disabled />
              </div>

              <div class="form-group">
                <label for="recipient-name" class="col-form-label">Current Password</label>
                <input type="text" v-model="current_pass" class="form-control" id="recipient-name" />
                <small v-if="passExists" class="text-success">
                  Password Match successfully !
                </small>
              </div>
              <div class="form-group">
                <label for="recipient-name" class="col-form-label">New Password</label>
                <input type="text" v-model="new_pass" class="form-control" id="recipient-name" />
              </div>
              <div class="form-group">
                <label for="recipient-name" class="col-form-label">Confirm password</label>
                <input type="text" v-model="conf_pass" class="form-control" id="recipient-name" />
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn close" data-bs-dismiss="modal">
              Close
            </button>
            <button @click="reset_pass_save()" type="submit" class="btn view">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Navbar End -->
</template>
<script>
import Swal from "sweetalert2";
import apis from "../apis";
import Loader from "@/components/Loader.vue";
import { Modal } from "bootstrap";
export default {
  components: { Loader },
  name: "HrmsUiSiteNavBarLanding",
  computed: {
    userdetails() {
      var nme = this.$store.getters.loggedUser;
      return nme.data;
    },
    userName() {
      var nme = this.$store.getters.loggedUser;
      this.username = nme.data.user_name;
      return nme.data.user_name;
    },
    employee_id() {
      var info = this.$store.getters.loggedUser;
      return info.data.employee_id;
    },
    menus() {
      var nme = this.$store.getters.loggedUser;
      return nme.data.menu_data;
    },
    Dashboard_link() {
      var info = this.$store.getters.loggedUser; console.log(info);
      return info.data.Dashboard_link;
    }
  },
  data() {
    return {
      isLoading: false,
      new_pass: "",
      conf_pass: "",
      username: "",
      current_pass: "",
      existingCurrentPass: "",
      passExists: false,
      errors: '',
    };
  },
  // mounted() { this.passwordMatch() },
  methods: {
    validatePassword(password) {


      if (password.length < 8) {
        return "Password must be at least 8 characters long.";
      }
      else if (!/[A-Z]/.test(password)) {
        return "Password must contain at least one uppercase letter.";
      }
      else if (!/[a-z]/.test(password)) {
        return "Password must contain at least one lowercase letter.";
      }
      else if (!/[0-9]/.test(password)) {
        return "Password must contain at least one digit.";
      }
      else if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
        return "Password must contain at least one special character.";
      }
      else if (/\s/.test(password)) {
        return "Password must not contain spaces.";
      }
      else {
        return "success";
      }
    },
    async reset_pass_save() {
      if (!this.new_pass && !this.conf_pass) {
        Swal.fire({
          icon: "error",
          title: "Error",
          width: 350,
          text: "Enter both new password and confirm password",
        });
        return false;
      }
      if (this.new_pass !== this.conf_pass) {
        Swal.fire({
          icon: "error",
          title: "Error",
          width: 350,
          text: "New password does not match with confirm password",
        });
        return false;
      }
      var check = this.validatePassword(this.new_pass);
      if (check !== 'success') {
        Swal.fire({
          icon: "error",
          title: "Error",
          width: 350,
          text: check,
        });
        return false;
      }

      if (this.current_pass === this.existingCurrentPass) {
        var details = {
          employee_id: this.userdetails.employee_id,
          password: this.new_pass
        }
        this.isLoading = true;
        const response = await apis.reset_password(details);
        this.isLoading = false;
        if (response.data.status === true) {
          Swal.fire({
            icon: "success",
            title: "Success",
            width: 350,
            text: response.data.message
          });

          const modalElement = document.getElementById("resetModal");
          const modal = bootstrap.Modal.getInstance(modalElement) ||
            new bootstrap.Modal(modalElement);
          modal.hide();
          this.logout();
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            width: 350,
            text: response.data.message
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          width: 350,
          text: "Current password does not match.",
        });
      }
    },
    resetpassword() {
      this.new_pass = "";
      this.conf_pass = "";

      const modal = new bootstrap.Modal(
        document.getElementById("resetModal")
      );
      modal.show();
      this.passwordMatch();
    },
    async passwordMatch() {
      try {
        const payload = {
          employee_id: this.employee_id,
        }
        console.log("employee-id", payload);
        const response = await apis.getPassword(payload);
        this.existingCurrentPass = response.data.password; // Extract the password
        //console.log("password:", this.existingCurrentPass);

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    profile() {
      this.$router.push({
        name: "profileview",
        params: {
          employee_id: this.employee_id,
        },
      });
    },
    gotolanding() {
      this.$router.push("/");
    },
    logout() {
      this.$store.dispatch("logout");
      this.$router.push("/");
    },
  },
  watch: {
    current_pass(newCurrentPass) {
      const checkedPass = newCurrentPass.trim();
      this.passExists =
        checkedPass !== "" && checkedPass === this.existingCurrentPass;
    },
  },
};
</script>
<style scoped>
.topbar-info {
  font-size: 10px;
  color: #fff;
  font-weight: 400;
}

/*** Topbar Start ***/
.topbar {
  padding: 2px 10px 2px 20px;
  background: #9172ff !important;
}

.topbar a,
.topbar a i {
  transition: 0.5s;
}

.topbar a:hover,
.topbar a i:hover {
  color: #f3e0c6 !important;
}

@media (max-width: 768px) {
  .topbar {
    display: none;
  }
}

.fixed-top .container {
  transition: 0.5s;
}

/*** Topbar End ***/
/*** Navbar Start ***/
.navbar {
  padding: 0;
}

.navbar .navbar-nav .nav-link {
  padding: 10px 15px;
  font-size: 16px;
  transition: 0.5s;
}

.navbar .navbar-nav .nav-link:hover,
.navbar .navbar-nav .nav-link.active,
.sticky-top.bg-white .navbar .navbar-nav .nav-link:hover,
.sticky-top.bg-white .navbar .navbar-nav .nav-link.active {
  color: #9172ff !important;
}

.navbar .dropdown-toggle::after {
  border: none;
  content: "\f107";
  font-family: "Font Awesome 5 Free";
  font-weight: 600;
  vertical-align: middle;
  margin-left: 8px;
}

@media (min-width: 1200px) {
  .navbar .nav-item .dropdown-menu {
    display: block;
    visibility: hidden;
    top: 100%;
    transform: rotateX(-75deg);
    transform-origin: 0% 0%;
    border: 0;
    transition: 0.5s;
    opacity: 0;
  }
}

@media (max-width: 1200px) {
  .navbar .collapse.navbar-collapse .btn-hover-bg.btn {
    margin-bottom: 20px;
  }
}

.dropdown .dropdown-menu a:hover {
  background: #f3e0c6 !important;
  color: #9172ff !important;
}

.dropdown .dropdown-menu p:hover {
  background: #f3e0c6 !important;
  color: #9172ff !important;
}

.dropdown .dropdown-menu b:hover {
  background: #f3e0c6 !important;
  color: #9172ff !important;
  cursor: pointer;
}

.navbar .nav-item:hover .dropdown-menu {
  transform: rotateX(0deg);
  visibility: visible;
  background: #f2f2f2 !important;
  transition: 0.5s;
  opacity: 1;
}

/*** Navbar End ***/

.employee-image {
  width: 50px;
  height: 50px;
  border-radius: 50%;


}

.view {
  padding: 10px;
  background-color: #714aff;

  height: 37px;
  margin-top: 10px;
  display: flex;
  font-size: 15px;
  font-weight: 600;
  align-items: center;
  color: #fff;
  border-radius: 5px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  justify-content: center;
  cursor: pointer;
  margin: 10px;
  text-decoration: none;
  border: none;
}
</style>